import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const COLOR_SELECTION_KEY = 'color-selection';

export const useColorSelectionOpenedState = () => {
  return useOpenedStateManager(COLOR_SELECTION_KEY);
};
